export class PhoneNumber {
  private readonly value: string;

  constructor(phoneNumber: string) {
    const cleaned = this.cleanPhoneNumber(phoneNumber);
    if (!this.isValid(cleaned)) {
      throw new Error(`Invalid phone number: ${phoneNumber}`);
    }
    this.value = cleaned;
  }

  static create(phoneNumber: string): PhoneNumber {
    return new PhoneNumber(phoneNumber);
  }

  getValue(): string {
    return this.value;
  }

  equals(other: PhoneNumber): boolean {
    return this.value === other.value;
  }

  toString(): string {
    return this.value;
  }

  getFormatted(): string {
    // Format as +1 (555) 123-4567 for US numbers
    if (this.value.startsWith('+1') && this.value.length === 12) {
      const digits = this.value.slice(2);
      return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return this.value;
  }

  private cleanPhoneNumber(phoneNumber: string): string {
    // Remove all non-digit characters except +
    let cleaned = phoneNumber.replace(/[^\d+]/g, '');
    
    // If no country code and starts with digit, assume US (+1)
    if (/^\d/.test(cleaned) && cleaned.length === 10) {
      cleaned = '+1' + cleaned;
    }
    
    return cleaned;
  }

  private isValid(phoneNumber: string): boolean {
    // Check for valid international format
    const internationalRegex = /^\+\d{1,3}\d{4,14}$/;
    return internationalRegex.test(phoneNumber) && phoneNumber.length >= 7 && phoneNumber.length <= 17;
  }

  getCountryCode(): string {
    const match = this.value.match(/^\+(\d{1,3})/);
    return match ? match[1] : '';
  }
}